import { IAction } from '../action/core';
import { UserType } from '../pages/login.d';

export interface IMainMenuProps {
    mainMenu?: Array<MenuItem>;
    organizationLogo?: string;
    mainMenuIsLoading?: boolean;
    dispatch?: any;
    culture?: any;
    headerBackgroundImage?: string;
    menuAnnouncementUnreadCount?: boolean;
    menuMessageUnreadCount?: boolean;
    userType?: UserType | null;
    iFrameSource?: any;
    organizationId?: string;
    isSimulate?: boolean;
    unreadMessageCount?: number;
    unreadAnnounceCount?: number;
    isMessageModelOpen?: boolean;
    triggerMessageModal?: any;
    isAlmsPlusLoginPage?: boolean;
    moduleItems?: any;
    twoFactorEmail?: string;
    loginFormData?: any;
    isLogin?: boolean;
    twoFactorVerificationError?: string;
    timeZone?: any;
}

export interface IMainMenuCourseProps {
    courseSubNavigationParam: string;
    activeStatus: number;
}

export interface IMainCourseMenuTabProps {
    menuPanelItems?: Array<{ name?: string, type?: number, count?: number }>;
    activeStatus?: number;
    courseSubNavigationTabParam?: string;
    courseMenuPanelItemsIsLoaded?: boolean;
    dispatch?: any;
    setEvent?: any;
    onClicked?: any;
}

export interface IMainCourseMenuContentProps {
    menuPanelItems?: Array<{ name?: string, type?: number, count?: number }>;
    mainMenuCourseContent?: Array<{ teachers?: string, name?: string, logoUrl?: string, progress?: string, classId?: string, courseId?: string, endDate?: string, startDate?: string }>;
    mainMmenuCourseContentIsLoaded?: false;
    courseSubNavigationTabParam?: string;
    tabActiveStatus?: number;
    history?: any;
    dispatch?: any;
    userType?: UserType;
}

export enum CourseSubNavigateType {
    aContinuing = 1, // Devam eden
    expired = 2, // Süresi Geçen
    willStartSoon = 3, // Yakında Başlıyacak
    archived = 4, // Arşivlenen
    allOf = 5, //
    teacherCourse = 6,    // Eğitmen verdiğim Dersleri
    archivedLessonsTeacher = 7    // Eğitmen Arşivlenen Dersleri
}

export interface MenuItem {
    staticLink?: string,
    name?: string,
    url?: string,
    htmlAttributes?: string,
    allowedRoles?: string,
    menuItemId: number,
    parentId?: number
}
